namespace GeniuzPOS.Inventory {
    export class IcStockReceiveDtColumns {
        static columnsKey = 'Inventory.IcStockReceiveDt';
    }
}
